export default __webpack_public_path__ + "static/media/balance_bike.69e05a59.jpg";